import { useKnockClient } from "@knocklabs/react";
import { requestInAppReview as requestInAppReviewAdapter } from "@src/appV2/NativeAdapters/inAppReview.adapter";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { Platform } from "@src/mobile/utils/platform";
import { useCallback } from "react";

import { KNOCK_LAST_REVIEW_PROMPTED_AT_ATTRIBUTE } from "./constants";

export interface UseRequestInAppReviewResult {
  /** Requests the native in-app review sheet. No-op on web / flag off / import failure. */
  requestInAppReview: () => Promise<void>;
}

export function useRequestInAppReview(): UseRequestInAppReviewResult {
  const isEnabled = useCbhFlag(CbhFeatureFlag.WORKPLACE_RATING_PROMPT, { defaultValue: false });
  const knockClient = useKnockClient();

  const requestInAppReview = useCallback(async () => {
    if (!isEnabled || !Platform.isMobile) {
      return;
    }

    try {
      await requestInAppReviewAdapter();
    } catch (error) {
      logError(APP_V2_APP_EVENTS.RATING_PROMPT_NATIVE_REQUEST_FAILED, { error });
      return;
    }

    try {
      await knockClient.user.identify({
        [KNOCK_LAST_REVIEW_PROMPTED_AT_ATTRIBUTE]: new Date().toISOString(),
      });
    } catch (error) {
      logError(APP_V2_APP_EVENTS.RATING_PROMPT_KNOCK_IDENTIFY_FAILED, { error });
    }
  }, [isEnabled, knockClient]);

  return { requestInAppReview };
}
